import { useEffect, useState } from "react";
import OrdersItem from "./OrdersItem";
import { orderApi } from "@/src/utils/api/order";
import _ from "lodash";
import Icons from "@/src/components/Icons";
import { digitsEnToFa } from "@persian-tools/persian-tools";
import moment from "jalali-moment";
import ModalOrder from "./ModalOrder";

function OrdersGroup() {
  const [data, setData] = useState<any>(null);
  const [dataGrouped, setDataGrouped] = useState<any>(null);
  const [dataItem, setDataItem] = useState<any>(null);
  const [itemsModal, setItemsModal] = useState<any>(null);
  const [showModal, setShowModal] = useState<boolean>(false);

  useEffect(() => {
    orderApi.activeOrders().then((res) => {
      setData(res.data);
      console.log(res.data);
      const grouped = _.groupBy(res.data.enterpriseList, (item) =>
        moment(item.deliveryDate).format("jYYYY-jMM-jDD")
      );
      setDataGrouped(grouped);
    });
  }, []);

  return (
    <div className="flex flex-col gap-4">
      {data &&
      data.enterpriseList &&
      data.enterpriseList.length > 0 &&
      dataGrouped ? (
        Object.entries(dataGrouped).map(([date, enterprises]: any) => (
          <>
            <div
              key={date}
              className="day-group rounded-xl border-gray-200-mmpz shadow-mmpz min-h-[186px] border p-3 "
            >
              <h4 className="font-bold text-xl py-2 px-2">
                سفارش‌های روز{" "}
                {digitsEnToFa(moment(date, "jYYYY-jMM-jDD").format("dddd"))}
              </h4>
              <p className="flex items-center mt-1 rounded-xl shadow-mmpz p-2 w-fit text-center ms-2 text-sm">
                <Icons
                  name="date"
                  fill="none"
                  size={20}
                  className="flex items-center me-2"
                />
                <span>{digitsEnToFa(date)}</span>
              </p>
              <div className="items mt-2">
                {(() => {
                  const allFoodsForThisDay = enterprises.flatMap(
                    (enterprise: any) => {
                      return data.foodList.filter(
                        (item: any) => item.menuId === enterprise.menuId
                      );
                    }
                  );

                  const groupedByFoodId = _.groupBy(
                    allFoodsForThisDay,
                    "foodId"
                  );

                  const uniqueItems = Object.values(groupedByFoodId)
                    .map((items: any) => ({
                      ...items[0],
                      count: _.sumBy(items, "count"),
                    }))
                    .sort((a, b) =>
                      a.foodType === "غذای اصلی" && b.foodType !== "غذای اصلی"
                        ? -1
                        : 1
                    );

                  return uniqueItems.length > 0 ? (
                    <div className="flex flex-col gap-4 mt-3">
                      {uniqueItems.map((item: any) => (
                        <div className="item rounded-xl" key={item.foodId}>
                          <div
                            className={`border border-gray-50-mmpz shadow-mmpz ${
                              item.foodType === "غذای اصلی"
                                ? "h-[60px]"
                                : "h-[42px]"
                            } rounded-xl p-2 flex justify-between items-center`}
                          >
                            <p className="mb-0 flex w-3/4">
                              {item.foodType === "غذای اصلی" ? (
                                <Icons name="food" size={24} className="me-2" />
                              ) : item.foodType === "کنار غذا" ? (
                                <Icons
                                  name="sideFood"
                                  size={18}
                                  className="me-2"
                                />
                              ) : (
                                <Icons
                                  name="other"
                                  size={18}
                                  className="me-2"
                                />
                              )}
                              {item.foodName}
                            </p>
                            <span className="font-bold text-gray-300-mmpz text-sm">
                              {digitsEnToFa(item.count)} عدد
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : null;
                })()}
              </div>
            </div>

            {enterprises.map((enterprise: any, index: any) => (
              <OrdersItem
                key={index}
                onClick={() => {
                  setItemsModal(
                    _.filter(
                      data.foodList,
                      (itemId: any) => itemId.menuId === enterprise.menuId
                    )
                  );
                  setDataItem(enterprise);
                  setShowModal(true);
                }}
                data={enterprise}
              />
            ))}
          </>
        ))
      ) : (
        <div className="day-group rounded-xl border-gray-100-mmpz shadow-mmpz min-h-[186px] border p-3">
          <h4 className="font-bold text-xl py-2 px-2">
            سفارش‌های روز{" "}
            {digitsEnToFa(moment(new Date().getTime()).format("dddd"))}
          </h4>
          <p className="flex items-center mt-1 rounded-xl shadow-mmpz p-2 w-fit text-center ms-2 text-sm">
            <Icons
              name="date"
              fill="none"
              size={20}
              className="flex items-center me-2"
            />
            <span>
              {digitsEnToFa(
                moment(new Date().getTime()).format("jYYYY-jMM-jDD")
              )}
            </span>
          </p>
          <div className="items mt-2 flex flex-col justify-center items-center">
            <Icons name="undefinedIcon" size={200} fill="none" />
            <h6 className="text-xl font-bold text-gray-200-mmpz">
              سفارشی برای شما ثبت نشده است.
            </h6>
          </div>
        </div>
      )}

      <ModalOrder
        open={showModal}
        close={() => setShowModal(false)}
        data={dataItem}
        items={itemsModal}
      />
    </div>
  );
}

export default OrdersGroup;
